export const SENSITIVE_DATA_OBFUSCATION_STORAGE_KEY =
    "docid.admin.obfuscate-sensitive-data";

export const SENSITIVE_DATA_OBFUSCATION_ATTRIBUTE =
    "data-sensitive-data-obfuscation";

